<!-- DB vehicles design-->
<app-modal
  #deleteImpactModal
  [modalMessage]="app.text.impact.deleteMessage"
  [modalTitle]="app.text.impact.modalTitle"
  (ok)="deleteImpact()"
></app-modal>
<app-modal
  #discardChangesModal
  [modalMessage]="app.text.impact.discard"
  (ok)="discardChanges(); app.impact.impactNameExist = false"
  >
</app-modal>
<div class="controls">
  <app-unlock
    [id]="app.impact.id"
    [permission]="
      app.impact.hasEditPermission(app.impact.id) && !app.impact.isNew
    "
    [title]="app.text.impact.editImpact"
    [hasText]="false"
    >
    @if (
      app.impact.modelHasChanges || app.impact.isNew) {
      @if (!hasInvalidFields() && !saveDisabled) {
        <button
          class="btn"
          (click)="save()"
          [title]="app.text.impact.save"
          >
          <i class="fa fa-check"></i>
        </button>
      }
      @if (app.impact.modelHasChanges) {
        <button
          class="btn"
          (click)="discardChangesModal.open()"
          [title]="app.text.impact.discard"
          >
          <i class="fa fa-times"></i>
        </button>
      }
    } @else {
      <button
        class="btn"
        (click)="discardChanges()"
        [title]="app.text.impact.close"
        >
        <i class="fa fa-times"></i>
      </button>
    }

  </app-unlock>
  @if (app.unlockedId == null) {
    <span>
      @if (!app.impact.isNew) {
        <span>
          @if (app.impact.hasEditPermission(app.impact.id)) {
            <button
              class="btn"
              (click)="deleteImpactModal.open()"
              [title]="app.text.impact.deleteImpact"
              >
              <i class="fa fa-trash"></i>
            </button>
          }
        </span>
      }
    </span>
  }
</div>
@if (
  app.field.getInvalidFields('impact', app.impact.currentImpact).length > 0 ||
  app.impact.impactNameExist
  ) {
  <div
    class="row error-message"
    >
    @if (app.unlockedId !== null) {
      <span>
        {{ app.text.impact.messageInvalidForm }}
        <ul>
          @for (
            invalidField of app.field.getInvalidFields(
            'impact',
            app.impact.currentImpact
            )
            ; track
            invalidField) {
            <li
              >
              {{ app.field.getLabel(invalidField) }}
            </li>
          }
        </ul>
        @if (app.impact.impactNameExist) {
          <ul>
            <li>
              {{ app.text.impact.impactNameExist }}
            </li>
          </ul>
        }
      </span>
    }
  </div>
}
@if (view === 'detailView') {
  <div class="descriptionList">
    @if (app.isLocked(app.impact.id)) {
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-6">
            <div class="flex">
              <div class="field-label" id="impact.omfVehicleName">
                {{ app.field.getLabel("impact.omfVehicleName") }}:&nbsp;
              </div>
              <div class="lineHeight" id="impact.omfVehicleName">
                {{ app.impact.currentImpact["impact.omfVehicleName"] }}
              </div>
            </div>
            <div class="flex">
              <div class="field-label" id="impact.omfVehicleFleet">
                {{ app.field.getLabel("impact.omfVehicleFleet") }}:&nbsp;
              </div>
              <div class="lineHeight" id="impact.omfVehicleFleet">
                {{ app.impact.currentImpact["impact.omfVehicleFleet"] }}
              </div>
            </div>
            <div class="flex">
              <div class="field-label" id="thread.omfStatus">
                {{ app.field.getLabel("thread.omfStatus") }}:&nbsp;
              </div>
              <div class="lineHeight" id="thread.omfStatus">
                {{ app.thread.thread["thread.omfStatus"] }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <ul class="legend-list col-md-6 pull-right">
              <li>
                <i class="fad fa-user-check"></i>&nbsp;
                <span class="lineHeight">{{ app.text.impact.greenBullet }}</span>
              </li>
              <li>
                <i class="fad fa-user-times"></i>&nbsp;
                <span class="lineHeight">{{ app.text.impact.redBullet }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    }
    @if (!app.isLocked(app.impact.id)) {
      <div class="col-md-12">
        <app-field
          [model]="app.impact.currentImpact"
          [field]="app.fieldId.impact.omfVehicleName"
          [disabled]="app.isLocked(app.impact.id)"
      (selected)="
        app.vehicleResponsible.setImpactDetails(
          app.impact.currentImpact[app.fieldId.impact.omfVehicleName]
        )
      "
        ></app-field>
        <app-field
          [model]="app.impact.currentImpact"
          [field]="app.fieldId.impact.omfVehicleFleet"
          [disabled]="app.isLocked(app.impact.id)"
        ></app-field>
      </div>
    }
    <!-- RESPONSIBLES FIELDS -->
    <div class="col-md-12">
      <div class="tableFixHead">
        <table class="table table-striped">
          <thead>
            <tr class="text-center">
              <th class="p-1">{{ app.text.responsibles.department }}</th>
              <th class="p-1">BAV</th>
              <th class="p-1"></th>
              <th class="p-1">MaWI</th>
              <th class="p-1"></th>
            </tr>
          </thead>
          @if (
            app.impact.currentImpact &&
            app.impact.currentImpact['impact.responsibles']
            ) {
            <tbody
              >
              @for (department of departments; track department; let i = $index) {
                <tr
                  id="{{ department.name }}"
                  >
                  <!-- DEPARTMENT NAME -->
                  <td class="p-1 text-center" id="{{ department.name }}">
                    <span class="department-name">{{ department.name }}</span>
                  </td>
                  <!-- BAV + BAV VERTRETER FIELDS -->
                  @if (!hasDifferentDisplay(department.name)) {
                    <td class="p-1">
                      <div
                        class="col-md-12 text-center"
                        id="{{ department.fields.bav }}"
                        >
                        <!-- BAV FIELDS / READ MODE & EDIT MODE-->
                        @if (app.isLocked(app.impact.id)) {
                          <div>
                            {{
                            app.users.getOptionName(app.impact.currentImpact["impact.responsibles"][
                            department.fields.bav
                            ])
                            }}
                          </div>
                        }
                        @if (!app.isLocked(app.impact.id)) {
                          <div>
                            <app-field
                              [model]="app.impact.currentImpact['impact.responsibles']"
                              [field]="department.fields.bav"
                              [disabled]="app.isLocked(app.impact.id)"
                              [showLabel]="false"
                            ></app-field>
                          </div>
                        }
                        <!-- VERTRETER FIELDS / READ MODE-->
                        @if (app.isLocked(app.impact.id)) {
                          <div
                            class="text-muted font-weight-light font-italic"
                            id="{{ department.fields.bavVertreter }}"
                            >
                            @if (display(department.fields.bavVertreter)) {
                              <small
                                class="text-muted font-weight-light font-italic"
                                >{{ app.text.impact.deputy }}:
                                {{
                                app.users.getOptionName(app.impact.currentImpact["impact.responsibles"][
                                department.fields.bavVertreter
                                ])
                                }}
                              </small>
                            }
                          </div>
                        }
                        <!-- VERTRETER FIELDS ON CREATE/EDIT MODE -->
                        @if (!app.isLocked(app.impact.id)) {
                          <span
                            id="{{ department.fields.bavVertreter }}"
                            >
                            <app-field
                              [model]="app.impact.currentImpact['impact.responsibles']"
                              [field]="department.fields.bavVertreter"
                              [disabled]="app.isLocked(app.impact.id)"
                              [showLabel]="true"
                            ></app-field>
                          </span>
                        }
                        <!-- SECOND VERTRETER FIELDS / READ MODE-->
                        @if (app.isLocked(app.impact.id)) {
                          <div
                            class="text-muted font-weight-light font-italic"
                            id="{{ department.fields.bavVertreter2 }}"
                            >
                            @if (display(department.fields.bavVertreter2)) {
                              <small
                                class="text-muted font-weight-light font-italic"
                                >{{ app.text.impact.secondDeputy }}:
                                {{
                                app.users.getOptionName(app.impact.currentImpact["impact.responsibles"][
                                department.fields.bavVertreter2
                                ])
                                }}
                              </small>
                            }
                          </div>
                        }
                        <!-- SECOND VERTRETER FIELDS ON CREATE/EDIT MODE -->
                        @if (!app.isLocked(app.impact.id)) {
                          <span
                            id="{{ department.fields.bavVertreter2 }}"
                            >
                            <app-field
                              [model]="app.impact.currentImpact['impact.responsibles']"
                              [field]="department.fields.bavVertreter2"
                              [disabled]="app.isLocked(app.impact.id)"
                              [showLabel]="true"
                            ></app-field>
                          </span>
                        }
                      </div>
                    </td>
                  }
                  <!-- SPECIAL CASE FOR STATUS 90 - BAV CARGO -->
                  @if (hasDifferentDisplay(department.name)) {
                    <td
                      class="p-1"
                      id="{{ department.fields.bavVertreter }}"
                      >
                      <div class="col-md-12 text-center">
                        <!-- BAV FIELDS / READ MODE & EDIT MODE-->
                        @if (app.isLocked(app.impact.id)) {
                          <div>
                            {{ app.users.getOptionName(app.impact.currentImpact["impact.responsibles"][
                            department.fields.bavVertreter
                            ])
                            }}
                          </div>
                        }
                        @if (!app.isLocked(app.impact.id)) {
                          <div>
                            <app-field
                              [model]="app.impact.currentImpact['impact.responsibles']"
                              [field]="department.fields.bavVertreter"
                              [disabled]="app.isLocked(app.impact.id)"
                              [showLabel]="false"
                            ></app-field>
                          </div>
                        }
                        <!-- VERTRETER FIELDS / READ MODE-->
                        @if (app.isLocked(app.impact.id)) {
                          <div
                            class="text-muted font-weight-light font-italic"
                            >
                            @if (display(department.fields.bav)) {
                              <small
                                class="text-muted font-weight-light font-italic"
                                id="{{ department.fields.bav }}"
                                >{{ app.text.impact.deputy }}:
                                {{
                                app.users.getOptionName(app.impact.currentImpact["impact.responsibles"][
                                department.fields.bav
                                ])
                                }}
                              </small>
                            }
                          </div>
                        }
                        <!-- VERTRETER FIELDS ON CREATE/EDIT MODE -->
                        @if (!app.isLocked(app.impact.id)) {
                          <span
                            id="{{ department.fields.bav }}"
                            >
                            <app-field
                              [model]="app.impact.currentImpact['impact.responsibles']"
                              [field]="department.fields.bav"
                              [disabled]="app.isLocked(app.impact.id)"
                              [showLabel]="true"
                            ></app-field>
                          </span>
                        }
                        <!-- SECOND VERTRETER FIELDS / READ MODE-->
                        @if (app.isLocked(app.impact.id)) {
                          <div
                            class="text-muted font-weight-light font-italic"
                            >
                            @if (display(department.fields.bavVertreter2)) {
                              <small
                                class="text-muted font-weight-light font-italic"
                                id="{{ department.fields.bavVertreter2 }}"
                                >{{ app.text.impact.secondDeputy }}:
                                {{
                                app.users.getOptionName(app.impact.currentImpact["impact.responsibles"][
                                department.fields.bavVertreter2
                                ])
                                }}
                              </small>
                            }
                          </div>
                        }
                        <!-- SECOND VERTRETER FIELDS ON CREATE/EDIT MODE -->
                        @if (!app.isLocked(app.impact.id)) {
                          <span
                            id="{{ department.fields.bavVertreter2 }}"
                            >
                            <app-field
                              [model]="app.impact.currentImpact['impact.responsibles']"
                              [field]="department.fields.bavVertreter2"
                              [disabled]="app.isLocked(app.impact.id)"
                              [showLabel]="true"
                            ></app-field>
                          </span>
                        }
                      </div>
                    </td>
                  }
                  <!-- RESPONSIBILTY STATUS  GREEN / RED FOR BAV FIELDS-->
                  @if (!hasDifferentDisplay(department.name)) {
                    <td class="p-1">
                      <button class="btn">
                        @if (
                          app.impact.displayBullet(
                          department.fields.bav,
                          green,
                          app.impact.currentImpact['impact.responsibles'],
                          app.impact.currentImpact['impact.omfVehicleName']
                          ) && app.unlockedId !== app.impact.id
                          ) {
                          <i
                            class="fad fa-user-check"
                          ></i>
                        }
                        @if (
                          app.impact.displayBullet(
                          department.fields.bav,
                          red,
                          app.impact.currentImpact['impact.responsibles'],
                          app.impact.currentImpact['impact.omfVehicleName']
                          ) && app.unlockedId !== app.impact.id
                          ) {
                          <i
                            class="fad fa-user-times"
                          ></i>
                        }
                      </button>
                    </td>
                  }
                  <!-- RESPONSIBILITY ON STATUS 90 / DEPARTMENT CARGO -->
                  @if (hasDifferentDisplay(department.name)) {
                    <td class="p-1">
                      <button class="btn">
                        @if (
                          app.impact.displayBullet(
                          department.fields.bavVertreter,
                          green,
                          app.impact.currentImpact['impact.responsibles'],
                          app.impact.currentImpact['impact.omfVehicleName']
                          ) && app.unlockedId !== app.impact.id
                          ) {
                          <i
                            class="fad fa-user-check"
                          ></i>
                        }
                        @if (
                          app.impact.displayBullet(
                          department.fields.bavVertreter,
                          red,
                          app.impact.currentImpact['impact.responsibles'],
                          app.impact.currentImpact['impact.omfVehicleName']
                          ) && app.unlockedId !== app.impact.id
                          ) {
                          <i
                            class="fad fa-user-times"
                          ></i>
                        }
                      </button>
                    </td>
                  }
                  <!-- MAWI + MAWI VERTRETER FIELDS -->
                  <td class="p-1">
                    <div
                      class="col-md-12 text-center"
                      id="{{ department.fields.mawi }}"
                      >
                      <!-- MAWI FIELDS ON READ & EDIT MODE -->
                      @if (app.isLocked(app.impact.id)) {
                        <div>
                          {{
                          app.users.getOptionName(app.impact.currentImpact["impact.responsibles"][
                          department.fields.mawi
                          ])
                          }}
                        </div>
                      }
                      @if (!app.isLocked(app.impact.id)) {
                        <div>
                          <app-field
                            [model]="app.impact.currentImpact['impact.responsibles']"
                            [field]="department.fields.mawi"
                            [disabled]="app.isLocked(app.impact.id)"
                            [showLabel]="false"
                          ></app-field>
                        </div>
                      }
                      <!-- MAWI  VERTRETER  FIELDS ON READ MODE -->
                      @if (app.isLocked(app.impact.id)) {
                        <div
                          class="text-muted font-weight-light font-italic"
                          id="{{ department.fields.mawiVertreter }}"
                          >
                          @if (display(department.fields.mawiVertreter)) {
                            <small
                              class="text-muted font-weight-light font-italic"
                              >{{ app.text.impact.deputy }}:
                              {{
                              app.users.getOptionName(app.impact.currentImpact["impact.responsibles"][
                              department.fields.mawiVertreter
                              ])
                              }}
                            </small>
                          }
                        </div>
                      }
                      @if (!app.isLocked(app.impact.id)) {
                        <span
                          id="{{ department.fields.mawiVertreter }}"
                          >
                          <app-field
                            [model]="app.impact.currentImpact['impact.responsibles']"
                            [field]="department.fields.mawiVertreter"
                            [disabled]="app.isLocked(app.impact.id)"
                            [showLabel]="true"
                          ></app-field>
                        </span>
                      }
                      <!-- MAWI SECOND VERTRETER FIELDS ON READ MODE -->
                      @if (app.isLocked(app.impact.id)) {
                        <div
                          class="text-muted font-weight-light font-italic"
                          id="{{ department.fields.mawiVertreter2 }}"
                          >
                          @if (display(department.fields.mawiVertreter2)) {
                            <small
                              class="text-muted font-weight-light font-italic"
                              >{{ app.text.impact.secondDeputy }}:
                              {{
                              app.users.getOptionName(app.impact.currentImpact["impact.responsibles"][
                              department.fields.mawiVertreter2
                              ])
                              }}
                            </small>
                          }
                        </div>
                      }
                      <!-- MAWI SECOND VERTRETER FIELDS ON CREATE/EDIT MODE -->
                      @if (!app.isLocked(app.impact.id)) {
                        <span
                          id="{{ department.fields.mawiVertreter2 }}"
                          >
                          <app-field
                            [model]="app.impact.currentImpact['impact.responsibles']"
                            [field]="department.fields.mawiVertreter2"
                            [disabled]="app.isLocked(app.impact.id)"
                            [showLabel]="true"
                          ></app-field>
                        </span>
                      }
                    </div>
                  </td>
                  <!-- RESPONSIBILTY STATUS  GREEN / RED FOR MAWI-->
                  <td class="p-1">
                    <button class="btn">
                      @if (
                        app.impact.displayBullet(
                        department.fields.mawi,
                        green,
                        app.impact.currentImpact['impact.responsibles'],
                        app.impact.currentImpact['impact.omfVehicleName']
                        ) && app.unlockedId !== app.impact.id
                        ) {
                        <i
                          class="fad fa-user-check"
                        ></i>
                      }
                      @if (
                        app.impact.displayBullet(
                        department.fields.mawi,
                        red,
                        app.impact.currentImpact['impact.responsibles'],
                        app.impact.currentImpact['impact.omfVehicleName']
                        ) && app.unlockedId !== app.impact.id
                        ) {
                        <i
                          class="fad fa-user-times"
                        ></i>
                      }
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          }
        </table>
      </div>
    </div>
  </div>
}
